module.exports = __webpack_public_path__ + "static/media/left_empty_triangle.f7800106.svg";